/* LALTERNATIVA — cassetto menu mobile.

   IL TASTO ACCEDI STA DENTRO LA LISTA, non ancorato al fondo del cassetto.

   Perche, visto che petalandpup.com invece lo ancora in fondo (misurato sul
   loro sito a 375x812: "Sign In" a y=749, 23px dal bordo): perche ancorarlo
   al fondo funziona solo se il cassetto finisce esattamente dove finisce lo
   schermo visibile, e su Chrome per iOS non ci siamo riusciti. Tentativi
   falliti, tutti verificati sul telefono vero:
     1. altezza calc(100dvh - offset)
     2. position:fixed con bottom:0
     3. altezza da window.visualViewport.height
     4. min() fra 100svh e la misura JS
     5. min() fra tre misure piu correzione a posteriori
   Ogni volta il pulsante finiva ~80px sotto il bordo, invisibile. Su quel
   browser 100vh, innerHeight e clientHeight danno il viewport DI LAYOUT, che
   resta alto anche con la barra degli strumenti in basso visibile.

   Messo in fondo alla lista delle voci il pulsante non dipende piu da nessuna
   misura di altezza: sta dove sta il testo. Il CSS gli da l'aspetto di un
   piede di menu (riga di separazione sopra e aria attorno) e non di un'ottava
   voce - vedi "ACCEDI" in assets/las-sticky-fix.css.

   Le misure --las-drawer-offset e --las-drawer-visible restano perche servono
   comunque a non far sforare il cassetto in generale.

   Fa anche un lavoro minore: tiene visibile la barra annunci, che spariva
   perche il focus automatico del tema faceva scorrere la pagina di ~26px. */
(function () {
  var drawer;

  function headerBottom() {
    var section = document.querySelector('.f-section-header');
    if (!section) return null;
    return Math.max(0, Math.round(section.getBoundingClientRect().bottom));
  }

  function visibleHeight() {
    var values = [];
    if (window.visualViewport && window.visualViewport.height) {
      values.push(window.visualViewport.height);
    }
    if (document.documentElement && document.documentElement.clientHeight) {
      values.push(document.documentElement.clientHeight);
    }
    if (window.innerHeight) values.push(window.innerHeight);
    if (!values.length) return 0;
    return Math.round(Math.min.apply(null, values));
  }

  function apply() {
    if (!drawer) return;
    var offset = headerBottom();
    if (offset !== null) {
      drawer.style.setProperty('--las-drawer-offset', offset + 'px');
    }
    var visible = visibleHeight();
    if (visible) {
      drawer.style.setProperty('--las-drawer-visible', visible + 'px');
    }
  }

  /* Sposta il blocco ACCEDI in fondo alla lista della schermata principale. */
  function placeAddons() {
    var addons = document.querySelector('.f-mobile-nav__addons');
    if (!addons || addons.dataset.lasMoved) return;
    var rootPanel = document.querySelector('.f-mobile-nav__panel[data-panel-id="root"]');
    if (!rootPanel) return;
    rootPanel.appendChild(addons);
    addons.dataset.lasMoved = '1';
  }

  function refresh() {
    apply();
    placeAddons();
  }

  function init() {
    drawer = document.querySelector('.f-drawer-mobile-nav');
    if (!drawer) return;
    refresh();

    var opener = document.querySelector('.mobile-nav-toggle');
    if (opener && !opener.dataset.lasBound) {
      opener.dataset.lasBound = '1';
      opener.addEventListener(
        'click',
        function () {
          var y = window.scrollY;
          var restore = function () {
            if (window.scrollY !== y) window.scrollTo(0, y);
            refresh();
          };
          if (window.requestAnimationFrame) window.requestAnimationFrame(restore);
          setTimeout(restore, 60);
          setTimeout(restore, 220);
          setTimeout(restore, 600);
        },
        true
      );
    }

    if (window.MutationObserver && !drawer.dataset.lasObserved) {
      drawer.dataset.lasObserved = '1';
      new MutationObserver(refresh).observe(drawer, {
        attributes: true,
        attributeFilter: ['open']
      });
    }

    window.addEventListener('resize', refresh);
    window.addEventListener('orientationchange', refresh);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', apply);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
